import { SettingConst } from '@faire/web-api--source/types';

/**
 * Feature toggle for enabling retailer website collection.
 */
export const ENABLE_BRAND_CONSOLIDATION_WEBSITE_COLLECTION_250722 =
  'ENABLE_BRAND_CONSOLIDATION_WEBSITE_COLLECTION_250722' as SettingConst<
    'ENABLE_BRAND_CONSOLIDATION_WEBSITE_COLLECTION_250722',
    boolean,
    'LOGGED_IN_RETAILER'
  >;
